import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { RefValue, DeletedAttachmentResponse, ProfileConfig, StandardPagableResponse } from '../interfaces/rdm-client.interface';
import { EnvironmentService } from './environment.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class RDMClientService {
  rdmData : Map<string , any> = new Map();
  loading = false;
  lodingSubscriber = new Subject();
  rdmUpdatedData = new Subject<boolean>();
  public rdmUpdate$ = this.rdmUpdatedData.asObservable();

  token!: string;
  constructor(private http: HttpClient, private env: EnvironmentService) { }

  addReferenceType(req: unknown): Observable<unknown> {
    const envValue:any = this.env.getEnvironment();
    const res = this.http.post<StandardPagableResponse>(envValue.baseUrl + envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/types", req);
    return res;
  }

  searchRDM(keyword: string | number | boolean, label: string | number | boolean, page: string | number | boolean, size: string | number | boolean): Observable<any> {
    const envValue:any = this.env.getEnvironment();
    const params = new HttpParams()
      .set('keyword', keyword)
      .set('label', label)
      .set('page', page)
      .set('size', size)
    const res = this.http.get<StandardPagableResponse>(envValue.baseUrl + envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/values/list", { params: params });
    return res;
  }

  addReferenceValues(req: unknown): Observable<unknown> {
    console.log('Request ', req);
    const envValue:any = this.env.getEnvironment();
    const res = this.http.post<StandardPagableResponse>(envValue.baseUrl + envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/values", req);
    return res;
  }

  deleteRefValue(id: number) {
    const envValue:any = this.env.getEnvironment();
    const res = this.http.delete<StandardPagableResponse>(envValue.baseUrl + envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/values/" + id);
    return res;
  }

  deleteRefType(id: number) {
    const envValue:any = this.env.getEnvironment();
    const res = this.http.delete<StandardPagableResponse>(envValue.baseUrl + envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/types/" + id);
    return res;
  }

  updateReferenceType(id: number, req:Record<string,unknown>): Observable<unknown> {
    const envValue:any = this.env.getEnvironment();
    return this.http.put<StandardPagableResponse>(envValue.baseUrl + envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/types/" + id, req );
  }

  updateReferenceValues(id: number,req:any): Observable<unknown> {
    const envValue:any = this.env.getEnvironment();
    return this.http.put<StandardPagableResponse>(envValue.baseUrl + envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/values/" + id,req);
  }

  getRefTs(): Observable<StandardPagableResponse> {
    const envValue:any = this.env.getEnvironment();
    return this.http.get<StandardPagableResponse>(envValue.baseUrl + envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/types")
  }

  getLOVs(label: string | number | boolean): Observable<StandardPagableResponse> {
    const envValue:any  = this.env.getEnvironment();
    const params = new HttpParams().set('label', label);
    return this.http.get<StandardPagableResponse>(envValue.baseUrl + envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/types", { params: params })
  }

  getAllRdmTypes(types: string[], status= 'api', page?:any, limit?:any, search?:any): Observable<any> {
    const envValue:any = this.env.getEnvironment();
    return this.http.post<unknown>(envValue.baseUrl + envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/"+ status+ "/v1/types/module", types)
  }

  getdependentLOVs(parentRefValue:any, code?: string): Observable<StandardPagableResponse> {
    const envValue:any = this.env.getEnvironment();
    const params = new HttpParams().set('parentRefValue', parentRefValue);
    if (code != null) params.append('code', code);
    return this.http.get<StandardPagableResponse>(envValue.baseUrl +envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/values", { params: params })
  }

  getReftValuesByParent(parentRefValue:any, code: string): Observable<StandardPagableResponse> {
    const envValue:any = this.env.getEnvironment();
    const params = new HttpParams().set('label', code).set('parent', parentRefValue);
    return this.http.get<StandardPagableResponse>(envValue.baseUrl +envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/types/parentRefvalue", { params: params })
  }

  /**
     * params = new HttpParams()
      .set('keyword', 'search key word')
      .set("label", ruleIndicatorSchema.refTypeCode)
      .set("page", (this.pagination.pageNumber-1).toString())
      .set("size", this.pagination.pageSize.toString());
     */
  findRefValuesBySearchQuery(label: string, queryParams: HttpParams) {
    const envValue:any = this.env.getEnvironment();
    return this.http.get<RefValue[]>(envValue.baseUrl +envValue.wso2amEndPoint+ "/rdm" + envValue.wso2amApiVersion + "/api/v1/values/list", {params: queryParams});
  }

  /**
     * params = new HttpParams()
      .set(rdmQueryParam, this.searchQuery)//rdmQueryParam-> refer -> src\assets\schemas\intellig\dga\new-schema.json
      .set("page", (this.pagination.pageNumber-1).toString())
      .set("size", this.pagination.pageSize.toString());
     */
  findRDMBySearchQuery(rdmPathParam: string, queryParams: HttpParams) {
    const envValue:any = this.env.getEnvironment();
    return this.http.get<StandardPagableResponse>(envValue.baseUrl +envValue.wso2amEndPoint+ "/dgardm" + envValue.wso2amApiVersion + "/api/v1"+rdmPathParam, {params: queryParams});
  }

  findTrustedTraderBySearchQuery(queryParams: any) {
    const envValue:any = this.env.getEnvironment();
    let params = new HttpParams();
    
    Object.keys(queryParams).forEach(key => {
      //if (queryParams[key] !== null && queryParams[key] !== undefined && queryParams[key] !== '') {
        params = params.set(key, queryParams[key]);
      //}
    });
    
    return this.http.get<StandardPagableResponse>(envValue.baseUrl +envValue.wso2amEndPoint+ "/intelligenceman" + envValue.wso2amApiVersion + 
    "/api/v1/aeointelligen/search", { params });
  }
  
  getRdmCodes(rdmCode:any){
    const envValue = this.env.getEnvironment();
    const params = new HttpParams().set('size', '10').set('page', '0');
    return this.http.get<StandardPagableResponse>(envValue.baseUrl +envValue.wso2amEndPoint+ "/dgardm" + envValue.wso2amApiVersion + "/api/v1/"+rdmCode, { params: params });
  }

  getEconomiesCodes(documentNo:any){
    const envValue:any = this.env.getEnvironment();
    const params = new HttpParams().set('documentNo', documentNo);
    return this.http.get<StandardPagableResponse>(envValue.baseUrl +envValue.wso2amEndPoint+ "/dgardm" + envValue.wso2amApiVersion + "/api/v1/economies", { params: params });
  }

  deleteAttachment(docId: string){
    const envValue:any = this.env.getEnvironment();
    return this.http.delete<DeletedAttachmentResponse>(envValue.baseUrl +envValue.wso2amEndPoint+ "/intelligenceman" + envValue.wso2amApiVersion + "/api/v1/risks/delete/file/" + docId);
  }

  getLastConfig(sort: string) {
    const envValue:any = this.env.getEnvironment();
    const params = new HttpParams().set('sort', sort);
    return this.http.get<any>(envValue.baseUrl +envValue.wso2amEndPoint+ "/intelligenceman" + envValue.wso2amApiVersion + "/api/v1/riskconfig/search", {params: params}); 
  }

  getConfigById(id: string) {
    const envValue:any = this.env.getEnvironment();
    return this.http.get<ProfileConfig>(envValue.baseUrl +envValue.wso2amEndPoint+ "/intelligenceman" + envValue.wso2amApiVersion + "/api/v1/riskconfig/view/"+ id);
  }

  createIntelligenceConfig(request: any) {
    const envValue:any = this.env.getEnvironment();
    return this.http.post<ProfileConfig>(envValue.baseUrl +envValue.wso2amEndPoint+ "/intelligenceman" + envValue.wso2amApiVersion + "/api/v1/riskconfig/create", request);
  }

  updateIntelligenceConfig(request: any, id: string) {
    const envValue:any = this.env.getEnvironment();
    return this.http.put<ProfileConfig>(envValue.baseUrl +envValue.wso2amEndPoint+ "/intelligenceman" + envValue.wso2amApiVersion + "/api/v1/riskconfig/update/"+ id, request);
  }

  deleteIntelligenceConfig(id: string) {
    const envValue:any = this.env.getEnvironment();
    return this.http.delete<ProfileConfig>(envValue.baseUrl +envValue.wso2amEndPoint+ "/intelligenceman" + envValue.wso2amApiVersion + "/api/v1/riskconfig/remove/"+id);
  }

  getBaseDeclaration(messageId: string): Observable<any> {
    const envValue:any = this.env.getEnvironment();
    return this.http.get<ProfileConfig>(envValue.baseUrl +envValue.wso2amEndPoint+ "/declaration" + envValue.wso2amApiVersion + "/api/v1/declarations/"+messageId);
  }

  getRiskMgmtTblData(referenceCode?: any, importer?: any, agentCode?: any, submitter?: any, validFrom?: any,
    inspectionAction?: any, validTo?: any, page?: any, size?: any, sort?: any, referanceType?:any, profileCode?: any, secretProfile?: any) {
    const envValue:any = this.env.getEnvironment();
    const params = new HttpParams().set('referenceCode', referenceCode)
      .set('importer', importer)
      .set('agentCode', agentCode)
      .set('submitter', submitter)
      .set('validFrom', validFrom)
      .set('inspectionAction', inspectionAction)
      .set('validTo', validTo)
      .set('page', page)
      .set('size', size)
      .set('sort', sort)
      .set('profileCode', profileCode)
      .set('referanceType', referanceType)
      .set('haveSecretProfile', secretProfile);
      return this.http.get<any>(envValue.baseUrl +envValue.wso2amEndPoint + '/intelligenceman' + envValue.wso2amApiVersion + "/api/v1/riskAss/search", {params : params});
  }


  manipulateData(val:any) {
    const temp = [];
    for (let i = 0; i < val.content.length; i++) {
      for (let j = 0; j < val.content[i].refValue.length; j++) {
        if (!val.content[i].refValue[j].label) {
          val.content[i].refValue[j]["label"] = val.content[i].refValue[j].code;
        }
        if (!val.content[i].refValue[j].value) {
          val.content[i].refValue[j]["value"] = val.content[i].refValue[j].code;
        }
        temp.push(val.content[i].refValue[j]);
      }
    }
    return temp
  }

  // getRefValueByCode(list: any[], code: string): RefValue { --Intial code,GIving Error
  getRefValueByCode(list: any[], code: string): any {
    for (let i = 0; i < list.length; i++)
      if (list[i].code == code) return list[i];
  }

  getRefValueByParentId(list: any[], id: number): any {
    for (let i = 0; i < list.length; i++)
      if (list[i].parentRefValue == id) return list[i];
  }

  getRefValueListByParentId(list: any[], id: number): any {
    let finalList = [];
    for (let i = 0; i < list.length; i++){
      if (list[i].parentRefValue == id) {
        finalList.push(list[i]);
      };
    }
    return finalList;
  }

  getIdfromLabel(label:any, arr:any) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].label == label) {
        return arr[i].code
      }
    }
  }

  getLabelFromId(id:any, arr:any) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].code == id) {
        return arr[i].label
      }
    }
  }

  
  getNameFromId(id:any, arr:any) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].code == id) {
        return arr[i].name
      }
    }
  }

  getIdfromCode(code:any, arr:any) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].code == code) {
        return arr[i].id
      }
    }
  }

  setRdmData(data:Map<string , any>) {
    this.rdmData = new Map([...this.rdmData , ...data]);
    this.rdmUpdatedData.next(true);
  }

  getRefValues(type: string, parentCode?: string) {
    let data:any = (this.rdmData && this.rdmData.has(type)) ? this.rdmData.get(type) : [];
    if (!_.isEmpty(data) && !_.isEmpty(parentCode)) {
      data = _.filter(data, { parentRefValue: parentCode });
    }
    return data;
  }

  addRefValue(type: string, refValue: any): Observable<any> {
    const envValue = this.env.getEnvironment();
    const refTypeId = this.getRefTypeId(type);
    const payload = {
      refTypeId: refTypeId,
      code: refValue.code,
      label: refValue.label,
      description: refValue.description || refValue.label,
      status: true,
      otherDescription: refValue.otherDescription || refValue.label
    };
    return this.http.post<any>(envValue.baseUrl + envValue.wso2amEndPoint + envValue.wso2amApiVersion + "/rdm/api/v1/values", payload);
  }

  private getRefTypeId(type: string): number {
    const typeMap: { [key: string]: number } = {
      'kc-profile-action-source': 404,
      'kc-profile-treatment-recommended-actions': 14
    };
    return typeMap[type] || 8;
  }

  putRefValues(type: string, refValues:any) {
    this.rdmData.set(type, refValues);
  }

  declarationDtoFromRefValues(refValues: RefValue[]): any {
    return refValues.map(e => {
      return { accountNumber: e.code, customerName: e.label, customerEmail: e.refTypeId, customerType: e.description,
        id: e.id, orgId: e.parentRefValue, customerCreatedOn: e.effectiveDateFrom };
    });
  }

  refValueFromDeclarationDto(declarationDtos: any): RefValue[] {
    return declarationDtos.map((e:any) => {
      return { code: e.accountNumber, label: e.customerName, description: e.customerType, refTypeId: e.customerEmail,
        id: e.id, parentRefValue: e.orgId, effectiveDateFrom: e.customerCreatedOn };
    });
  }

  getRiskAssManBLProfileEntities(profileId: string, page:any, size:any, sort:any): Observable<any> {
    const envValue = this.env.getEnvironment();
    const params = new HttpParams()
      .set('page', page)
      .set('size', size)
      .set('sort', sort)
    return this.http.get<ProfileConfig>(envValue.baseUrl +envValue.wso2amEndPoint+ "/intelligenceman" + envValue.wso2amApiVersion + "/api/v1/riskAss/ec/manifest-bl/" + profileId, { params });
  }

  getECManifestByID(id: string): Observable<any> | any {
    const envValue = this.env.getEnvironment();
    return this.http.get<ProfileConfig>(envValue.baseUrl +envValue.wso2amEndPoint+ "/intelligenceman" + envValue.wso2amApiVersion + "/api/v1/risk/ecmanifest/" + id);;
  }

  getRdmDataByRefTypeAndCode(
    refTypeCode: string,
    code: string | undefined
  ): string {
    const [item] = this.getRefValues(refTypeCode).filter((item: any) => item.code == code);
    if (item) return item.description;
    else return "NA";
  }

  getRdmDataLabelByRefTypeAndCode(
    refTypeCode: string,
    code: string | undefined
  ): string {
    const [item] = this.getRefValues(refTypeCode).filter((item: any) => item.code == code);
    if (item) return item.label;
    else return "NA";
  }

  getAllCustomers(traderInfo: any): Observable<any> {
    const envValue:any = this.env.getEnvironment();
    return this.http.post<unknown>(envValue.baseUrl+envValue.wso2amEndPoint + "/clm" + envValue.wso2amApiVersion + "/api/v1/registrations/search", traderInfo)
  }

  searchRdmValuesByFilter(refTypeLabel: string, searchLabel: string = '', page: number = 0, size: number = 10, description?:any): Observable<any> {
    const envValue: any = this.env.getEnvironment();
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('refTypeLabel', refTypeLabel)
      .set('label', searchLabel)
      .set('description', description || '');
    return this.http.get<any>(envValue.baseUrl + envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/values/search/filter", { params });
  }

  searchRdmData(rdmKey: string, searchTerm: string, page: number = 0, size: number = 20): Observable<any> {
    const envValue: any = this.env.getEnvironment();
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('refTypeLabel', rdmKey)
      .set('codes', searchTerm);
    return this.http.get<any>(envValue.baseUrl + envValue.wso2amEndPoint + "/rdm" + envValue.wso2amApiVersion + "/api/v1/values/search/filter", { params });
  }

  searchLocationData(searchTerm: string, page: number = 0, size: number = 20): Observable<any> {
    const envValue: any = this.env.getEnvironment();
    let params = new HttpParams()
      .set('locationName', searchTerm)
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<any>(envValue.baseUrl + "/rdm/api/v1/locations/search", { params });
  }

  getCommodityHSCode(searchTerm: string, description: string, code: string, size: number = 20, page: number = 0): Observable<any> {
    const envValue: any = this.env.getEnvironment();
    let params = new HttpParams()
      .set('searchTerm', searchTerm)
      .set('description', description)
      .set('code', code)
      .set('size', size.toString())
      .set('page', page.toString());
    return this.http.get<any>(envValue.baseUrl + "/tariff/api/v1/commodity/search", { params });
  }

  getRefTypeMaster(): Observable<any> {
    const envValue: any = this.env.getEnvironment();
    return this.http.get<any>(envValue.baseUrl + "/rdm/api/v1/ref-type-master");
  }

    setRefTypeMaster(payload:any): Observable<any> {
    const envValue: any = this.env.getEnvironment();
    return this.http.post<any>(envValue.baseUrl + "/rdm/api/v1/ref-value-master",payload);
  }
}
